module.exports = "./img/desktop_logo.c45f7bd.png";